import React from 'react';
import {PortalWithState} from 'react-portal';
import PropTypes from 'prop-types';
import Button from '../Button';
import Modal from '../contact/Modal';

const ContactLink = ({size, variant}) => (
  <PortalWithState closeOnEsc={true}>
    {({openPortal, portal, closePortal}) => (
      <div>
        <Button onClick={openPortal} size={size} variant={variant}>
          Contact us
        </Button>
        {portal(<Modal close={closePortal} />)}
      </div>
    )}
  </PortalWithState>
);

ContactLink.propTypes = {
  size: PropTypes.oneOf(['small', 'medium']),
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'inverse',
    'inverseOutline',
  ]),
};

ContactLink.defaultProps = {
  size: 'small',
  variant: 'primary',
};

export default ContactLink;



// WEBPACK FOOTER //
// ./src/components/header/ContactLink.js